module.exports = __webpack_public_path__ + "static/media/bunker-hex.c8782e14.png";